import { demoPortfolio } from '../data/demo'
import type { PortfolioPayload } from '../types'

export class PortfolioAccessError extends Error {
  constructor(
    message: string,
    public code: 'LINK_REQUIRED' | 'LINK_EXPIRED' | 'NOT_FOUND' | 'UNKNOWN',
  ) {
    super(message)
  }
}

export async function loadPortfolio(): Promise<{ data: PortfolioPayload; demo: boolean }> {
  const token = new URLSearchParams(window.location.search).get('token')
  const query = token ? `?token=${encodeURIComponent(token)}` : ''

  try {
    const response = await fetch(`/api/portfolio${query}`, {
      headers: { Accept: 'application/json' },
    })

    // 单独运行 Vite 时没有 Pages Function，使用样例数据继续设计与内容录入。
    if (import.meta.env.DEV && response.status === 404) {
      return { data: demoPortfolio, demo: true }
    }

    if (response.status === 401) {
      throw new PortfolioAccessError('这个作品集需要有效的分享链接。', 'LINK_REQUIRED')
    }
    if (response.status === 410) {
      throw new PortfolioAccessError('分享链接已失效或已过期。', 'LINK_EXPIRED')
    }
    if (response.status === 404) {
      throw new PortfolioAccessError('暂时没有可展示的内容。', 'NOT_FOUND')
    }
    if (!response.ok) throw new Error(`Request failed: ${response.status}`)

    return { data: (await response.json()) as PortfolioPayload, demo: false }
  } catch (error) {
    if (error instanceof PortfolioAccessError) throw error

    // 本地未启动 Cloudflare Functions 时展示样例，方便先完成视觉与内容替换。
    if (import.meta.env.DEV) return { data: demoPortfolio, demo: true }
    throw new PortfolioAccessError('页面暂时无法加载，请稍后重试。', 'UNKNOWN')
  }
}
